<template>
  <div class="mains">
    <div class="campus">
      学生测试
      <span>></span>
      测试管理
    </div>
    <div class="student_test">

      <el-card>
        <div class="grid-content">
          <div class="rule">
            <div class="xiaoqu_1">测试管理</div>
            <div class="xiaoqu_2">
              <div @click="dialogFormVisible4=true"><div class="icon_change"></div>
              切换系列</div>
              
            </div>
          </div>
            <el-dialog title="选择系列" :visible.sync="dialogFormVisible4">
              <el-form>
                <el-form-item label="小程序名称" :label-width="formLabelWidth">
                  <el-select v-model="appletList" placeholder="请选择小程序" @change="changeDisabled()">
                    <el-option v-for="item in xcxList" :value="item.id" :label="item.name" :key="item.id" @click.native="miniid=item.id">{{item.name}}</el-option>
                  </el-select>
                </el-form-item>
                <i>
                  <img src="@/assets/img/education-manage/campus/bitian.png" alt />
                </i>
                <el-form-item label="系列名称" :label-width="formLabelWidth">
                  <el-select v-model="bookSeries" placeholder="请选择系列" :disabled="disabled" @visible-change="referOrganzationList()">
                    <el-option v-for="item in bookList" :value="item.name" :key="item.id" @click.native="groupId=item.groupid">{{item.name}}</el-option>
                  </el-select>
                </el-form-item>
              </el-form>
              <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submit();dialogFormVisible4 = false">确 定</el-button>
                <el-button @click="dialogFormVisible4 = false">取 消</el-button>
              </div>
            </el-dialog>
            <router-link :to="'newTest/'+this.miniid+'/'+this.groupId">
              <el-button type="primary" @click="dialogFormVisible = true">+ 制作试题</el-button>
              </router-link>
          

          <span class="hint">注：此部分是您上传等级习题的模块，您可通过“制作习题”进行等级测试题的制作，并在制作中添加等级标签进行测试题的等级区分</span>

          <div class="zsbg">
            <el-table :data="dataTable" border style="width: 100%">
              <el-table-column prop="title" label="试题标题" max-width="360"></el-table-column>
              <el-table-column prop="levelName" label="试题标签" max-width="360"></el-table-column>
              <el-table-column prop="createDate" label="创建时间"></el-table-column>
               <el-table-column prop="isValid" label="状态">
                   <!-- <template slot-scope="scope">
                    <el-button type=text @click="state(scope.row.isValid)">{{states}}</el-button>
                   </template> -->
               </el-table-column>
               
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <router-link :to="'lookText/'+scope.row.textId">
                    <el-button type="text">查看等级试题</el-button>
                    </router-link>
                  <router-link :to="'editText/'+scope.row.textId"> 
                    <el-button type="text">编辑试题</el-button>
                  </router-link>
                  <el-button type="text" @click="removeItem(scope.row.textId)">删除试题</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[5, 10, 30, 50, 100]" :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogTableVisible: false,
      dialogFormVisible: false,
      dataTable:[],
      bookList:[],
      bookSeries:[],
      disabled:'',
      formLabelWidth: '120px',
      xcxList:[],
      miniid:'',
      groupId:'',
      appletList:'',
      currentPage: 1,
      currentPages: 1,
      dialogFormVisible4:false,
      total:0,
      pageSize:1,
      states:'',
    };
  },
  computed: {},
  created() {
    this.referXCXList();
    this.dialogFormVisible4 = true;
  },
  destroyed() {},
  methods: {
    submit(){
      this.referOrganzationList();
      this.setItemList();
    },
    //查询机构列表
    referOrganzationList() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let orgid = window.sessionStorage.getItem('orgid');
      console.log(this.miniid);
      let pro = this.$http({
        url: '/edu/exam/readGrade/book/series',
        method: 'GET',
        params: {
          miniid: this.miniid,
          orgid: orgid,
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro.then((res) => {
        this.bookList = res.data.data;
      });
    },
    //查询小程序列表
    referXCXList() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let orgid = window.sessionStorage.getItem('orgid');
      let url = '/edu/exam/readGrade/applets/' + orgid;
      let pro = this.$http({
        url: url,
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro.then((res) => {
        console.log(res.data.data, 'xcx');
        this.referOrganzationList();
        this.xcxList = res.data.data;
      });
    },
      //小程序禁用与打开
    changeDisabled() {
      this.referOrganzationList();
      this.disabled = false;
    },
    // addtest() {
    //   this.$router.push({
    //     path: '/newTest',
    //   });
    // },

    setItemList(){
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
      url: '/edu/exam/readGrade/text?miniid='+this.miniid+'&groupId='+this.groupId+'&level=&page=&pageSize=5',
      headers: {
        Authorization: 'Bearer ' + token,
      },
    });
    pro
      .then((res) => {
        console.log(res, '查看');
        if (res.data.code === 0) {
          let data = res.data.data;
          this. dataTable = data;
          this.total = res.data.data.length;
          this.state();
        }
      })
      .catch(() => {
        console.log(222);
      });
    },
  
    
    //删除
    removeItem(textId) {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/exam/readGrade/text/'+textId+'/del',
        method: 'POST',
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro.then((res) => {
        console.log(res,"shanchu");
        if (res.data.code !== 0) {
          return this.$message.error(res.data.message);
        }this.setItemList();
      });
    },
     handleSizeChange(val) {
      this.pageSize = val;
      this.page = 1;
      this.currentPage = 1;
      this.setItemList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.setItemList();
    },
  },
};
</script>

<style lang="less">
.rule {
  position: relative;
  margin-top: -20px;
  .xiaoqu_1 {
    font-weight: Bold;
  }

  .xiaoqu_2 {
    position: absolute;
    font-weight: 600;
    font-size: 18px;
    top: 3px;
    right: 0;
    .icon_change {
      position: absolute;
      width: 22px;
      height: 22px;
      right: 77px;
      border-radius: 50%;
      padding: 0;
      background: url('../../../assets/img/home/qiehuan_1.png') #00a6e6 no-repeat center;
      background-size: 0.85vw;
    }
  }
}
</style>
<style>
.hint {
  display: inline-block;
  color: #f66200;
  font-size: 0.875rem /* 14/16 */;
  margin-left: 1.25rem /* 20/16 */;
}
.bottom-card {
  display: flex;
  margin-top: 21px;
}
.bottom-card-left {
  padding-right: 7px;
}
.bottom-card-right {
  padding-left: 7px;
}
.btn-hint {
  display: flex;
}
</style>
